module.exports = __webpack_public_path__ + "static/media/hawaii-selfie.58957290.jpg";